import React from 'react';
import i18n from '../i18n';

/**
 * ErrorBoundary уровня страницы: падение одного компонента (например,
 * lightweight-charts на экзотических данных) раньше клало весь UI в белый
 * экран. Теперь — деградация по-странично с кнопкой перезагрузки панели.
 */
type State = { error: Error | null };

export class PageErrorBoundary extends React.Component<React.PropsWithChildren, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[page-error]', error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex flex-col items-center justify-center gap-3 p-10 text-sm">
          <div className="font-semibold">{i18n.t('pageErrorBoundary:title')}</div>
          <div className="max-w-lg break-all text-center font-mono text-xs text-muted-foreground">
            {String(this.state.error?.message || this.state.error)}
          </div>
          <button
            onClick={() => this.setState({ error: null })}
            className="rounded-md border border-border bg-card px-3 py-1.5 text-xs hover:bg-secondary"
          >
            {i18n.t('pageErrorBoundary:retry')}
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
